/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ProductContestFragment = {
    __typename: 'ProductContest';
    category: string;
    pricing: {
        __typename: 'FixedPrice';
        amounts: Array<{ __typename: 'Money'; currency: string; amountInCents: number }>;
    };
};

export type ProductFixedPriceProjectFragment = {
    __typename: 'ProductFixedPriceProject';
    category: string;
    pricing: {
        __typename: 'FixedPrice';
        amounts: Array<{ __typename: 'Money'; currency: string; amountInCents: number }>;
    };
};

export type ContestPriceQueryVariables = Types.Exact<{
    names?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type ContestPriceQuery = {
    __typename: 'Query';
    products: Array<
        | ({ __typename: 'ProductFixedPriceProject' } & ProductFixedPriceProjectFragment)
        | ({ __typename: 'ProductContest' } & ProductContestFragment)
        | { __typename: 'ProductQuotedProject' }
    >;
};

export const ProductContestFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductContest' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductContest' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amounts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'amountInCents' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ProductFixedPriceProjectFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amounts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'amountInCents' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const ContestPriceDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ContestPrice' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'names' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'names' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'names' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ProductContest' },
                                },
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ProductFixedPriceProject' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductContest' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductContest' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amounts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'amountInCents' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amounts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'amountInCents' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useContestPriceQuery__
 *
 * To run a query within a React component, call `useContestPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContestPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContestPriceQuery({
 *   variables: {
 *      names: // value for 'names'
 *   },
 * });
 */
export function useContestPriceQuery(
    baseOptions?: Apollo.QueryHookOptions<ContestPriceQuery, ContestPriceQueryVariables>
) {
    return Apollo.useQuery<ContestPriceQuery, ContestPriceQueryVariables>(
        ContestPriceDocument,
        baseOptions
    );
}
export function useContestPriceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ContestPriceQuery, ContestPriceQueryVariables>
) {
    return Apollo.useLazyQuery<ContestPriceQuery, ContestPriceQueryVariables>(
        ContestPriceDocument,
        baseOptions
    );
}
export type ContestPriceQueryHookResult = ReturnType<typeof useContestPriceQuery>;
export type ContestPriceLazyQueryHookResult = ReturnType<typeof useContestPriceLazyQuery>;
export type ContestPriceQueryResult = Apollo.QueryResult<
    ContestPriceQuery,
    ContestPriceQueryVariables
>;
